import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';

export default class StockTaking extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'stocktaking',
            refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            data: null,
            loading: true,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost('api/v1/stocktaking/get', {
            id: this.state.id,
        }).then((data) => {
            if (data.status === -1) window.location.href = '/login';
            if (data.status === 1) {
                window.organizationId = data.global.company.id;
                this.state.data = data;
                this.state.loading = false;
                this.updateFormula();
            } else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false,
                });
            }
        });
    }
    save(e, status) {
        e.preventDefault();
        if (this.isBlank(this.state.data.record.number)) this.state.data.record.number = 0;

        this.httpPost('api/v1/stocktaking/save', {
            id: this.state.id,
            organizationId: this.state.data.global.company.id,
            number: this.state.data.record.number,
            description: this.state.data.record.description,
            warehouseId: this.state.data.record.warehouseId,
            status,
            items: this.state.data.record.items,
        }).then((data) => {
            if (data.status === -1) window.location.href = '/login';
            if (data.status === 1) {
                this.showSuccessMessage('درخواست با موفقیت ذخیره شد');

                if (this.state.refreshCallerAfterSave)
                    this.state.caller.refreshData();

                this.closeMe();
            } else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false,
                });
            }
        });
    }
    getBlankRow(defaultIndex = null) {
        return {
            id: this.uuidv4(),
            index: defaultIndex == null ? this.state.data.record.items.length + 1 : defaultIndex,
            stuffId: this.defaultGuid(),
            stuffName: '',
            secondCountQty: 0,
            description: '',
            unitId: this.defaultGuid(),
            unitName: '',
            differenceQty: 0,
            finalQty: 0,
            firstCountQty: 0,
            systemQty: 0,
            thirdCountQty: 0,
        };
    }
    addBlankRow() {
        this.state.data.record.items.push(this.getBlankRow());
    }
    removeRow(id) {
        var temp = [];
        var index = 1;
        this.state.data.record.items
            .sort((a, b) => a.index - b.index)
            .forEach((r) => {
                if (r.id != id) {
                    temp.push(r);
                    temp[temp.length - 1].index = index;
                    index++;
                }
            });
        this.state.data.record.items = temp;
        this.updateFormula();
    }
    copyRow(id) {
        var clone = null;
        this.state.data.record.items.forEach((i) => {
            if (i.id === id) {
                clone = Object.assign({}, i);
            }
        });
        clone.id = this.uuidv4();
        var startIndex = clone.index;
        for (var i = 0; i < this.state.data.record.items.length; i++) {
            if (this.state.data.record.items[i].index > startIndex)
                this.state.data.record.items[i].index++;
        }
        clone.index++;
        this.state.data.record.items.push(clone);
        this.updateFormula();
    }
    upIndex(id) {
        var idIndex = -1;
        this.state.data.record.items.forEach((r, index) => {
            if (r.id == id) idIndex = index;
        });
        if (idIndex != -1 && idIndex > 0) {
            var ii = this.state.data.record.items[idIndex].index;
            this.state.data.record.items[idIndex].index = ii - 1;
            this.state.data.record.items[idIndex - 1].index = ii;
            this.setState({ data: this.state.data });
        }
    }
    downIndex(id) {
        var idIndex = -1;
        this.state.data.record.items.forEach((r, index) => {
            if (r.id == id) idIndex = index;
        });
        if (idIndex != -1 && idIndex < this.state.data.record.items.length - 1) {
            var ii = this.state.data.record.items[idIndex].index;
            this.state.data.record.items[idIndex].index = ii + 1;
            this.state.data.record.items[idIndex + 1].index = ii;
            this.setState({ data: this.state.data });
        }
    }
    setBodyValue(id, field, value) {
        for (var i = 0; i < this.state.data.record.items.length; i++) {
            if (this.state.data.record.items[i].id === id) {
                if (field == 'stuffId' || field == 'unitId') {
                    if (field == 'stuffId') {
                        this.state.data.record.items[i][field] = value.value;
                        this.state.data.record.items[i]['count'] = value.defaultAmount;
                        if (!this.isNull(value.description))
                            this.state.data.record.items[i]['description'] = value.description;
                        this.state.data.record.items[i]['unitId'] = value.unitId;
                        this.state.data.record.items[i]['unitName'] = value.unitName;
                        this.state.data.record.items[i]['stuffName'] = value.label;

                    }
                    if (field == 'unitId') {
                        this.state.data.record.items[i][field] = value.value;
                        this.state.data.record.items[i]['unitName'] = value.label;
                    }
                } else {
                    this.state.data.record.items[i][field] = value;
                }

                this.state.data.record.items[i].differenceQty = this.state.data.record.items[i].finalQty - this.state.data.record.items[i].systemQty;
            }
        }
        this.updateFormula();
    }
    updateFormula() {

        var hasBlankRow = false;

        for (var i = 0; i < this.state.data.record.items.length; i++) {
            if (this.state.data.record.items[i].stuffId == this.defaultGuid())
                hasBlankRow = true;
        }

        if (!hasBlankRow && this.state.data.record.status === 1) this.addBlankRow();

        this.setState({ date: this.state.data });
    }
    //override
    remove() {
        var id = this.state.id_to_remove;
        if (this.isNull(id) && !this.isNull(this.state.selectedIds)) id = this.state.selectedIds;

        this.httpPost("api/v1/" + this.state.controllerName + "/remove", {
            id,
            companyId: this.state.data.global.company.id,
            organizationId: this.state.data.global.company.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({ showConfirmRemove: false });
                }
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    getLastBodyId() {
        return this.state.data.record.items.sort((a, b) => b.index - a.index)[0].id;
    }
    renderForm() {
        const customStyles = {
            control: (base, state) => ({
                ...base,
                border: "none",
                boxShadow: "none",
                backgroundColor: "transparent",
                minHeight: "30px",
                height: "30px",
                fontSize: "14px",
            }),
            dropdownIndicator: (base) => ({
                ...base,
                padding: 4,
            }),
            clearIndicator: (base) => ({
                ...base,
                padding: 4,
            }),
            valueContainer: (base) => ({
                ...base,
                padding: "0 6px",
            }),
            input: (base) => ({
                ...base,
                margin: 0,
                padding: 0,
            }),
            menu: (base) => ({
                ...base,
                zIndex: 9999,
            }),
        };
        return [
            <div className="modal-backdrop fade show"></div>,
            <div className="modal fad  modal-full-96 show opened" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <span className="modal-title">شمارش کالاهای انبار</span>
                            <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={(e) => this.closeMe()}>
                                <span>×</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <div className="row">
                                <div className="col-lg-3">
                                    <label className="form-label">انبار</label>
                                    {this.state.data.record.status === 1 ? <SelectAsync
                                        defaultValue={
                                            this.state.data.record.warehouseId != this.defaultGuid()
                                                ? [
                                                    {
                                                        value: this.state.data.record.warehouseId,
                                                        label: this.state.data.record.warehouseName,
                                                    },
                                                ]
                                                : null
                                        }
                                        isMulti={false}
                                        placeholder="انتخاب"
                                        noOptionsMessage={({ inputValue }) =>
                                            inputValue ? "نتیجه‌ای یافت نشد" : null
                                        }
                                        components={{
                                            DropdownIndicator: () => null,
                                            IndicatorSeparator: () => null,
                                        }}
                                        defaultOptions={[]}
                                        loadOptions={this.loadWarehousesOptions}
                                        onChange={(e) => {
                                            this.state.data.record.warehouseId = e.value;
                                            this.state.data.record.warehouseName = e.labe;
                                            this.setState({ data: this.state.data });
                                        }}
                                    /> : <span>{this.state.data.record.warehouseName}</span>}
                                </div>
                                <div className="col-lg-1">
                                    <label className="form-label">شماره</label>
                                    {this.state.data.record.status === 1 ? <input
                                        onChange={(e) => (this.state.data.record.number = parseInt(e.target.value))}
                                        defaultValue={this.state.data.record.number}
                                        autoComplete="off"
                                        type="text"
                                        className="form-input ltr"
                                        maxLength="20"
                                    /> : <span>{this.state.data.record.number}</span>}
                                </div>
                                <div className="col-md-12">
                                    <label className="form-label">توضیحات</label>
                                    <input
                                        onChange={(e) => (this.state.data.record.description = e.target.value)}
                                        defaultValue={this.state.data.record.description}
                                        autoComplete="off"
                                        type="text"
                                        className="form-input"
                                        style={{ width: '100%' }}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <table className="invoices-table persons-table">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '30px' }}>#</th>
                                                <th>آیتم</th>
                                                <th>واحد</th>
                                                <th>شرح</th>
                                                {(this.state.date.record.status !== 1 && this.state.date.record.status !== 7) && <th style={{ width: '80px' }}><span>موجودی سیستم</span></th>}
                                                {(this.state.date.record.status === 2 || this.state.date.record.status === 3 || this.state.date.record.status === 4 || this.state.date.record.status === 5 || this.state.date.record.status === 6 || this.state.date.record.status === 8) && <th style={{ width: '80px' }}><span>شمارش اول</span></th>}
                                                {(this.state.date.record.status === 3 || this.state.date.record.status === 4 || this.state.date.record.status === 5 || this.state.date.record.status === 6 || this.state.date.record.status === 8) && <th style={{ width: '80px' }}><span>شمارش دوم</span></th>}
                                                {(this.state.date.record.status === 4 || this.state.date.record.status === 5 || this.state.date.record.status === 6 || this.state.date.record.status === 8) && <th style={{ width: '80px' }}><span>شمارش سوم</span></th>}
                                                {(this.state.date.record.status === 5 || this.state.date.record.status === 6 || this.state.date.record.status === 8) && <th style={{ width: '80px' }}><span>موجودی نهایی</span></th>}
                                                {(this.state.date.record.status === 5 || this.state.date.record.status === 6 || this.state.date.record.status === 8) && <th style={{ width: '80px' }}><span>اختلاف</span></th>}
                                                {this.state.data.record.status === 1 && <th style={{ width: '35px' }}></th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.data.record.items.sort((a, b) => a.index - b.index).map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>
                                                        <label>{index + 1}</label>
                                                        <div className="d-flex invoice-arrow-container">
                                                            {index > 0 &&
                                                                index != this.state.data.record.items.length - 1 && (
                                                                    <a onClick={(e) => this.upIndex(item.id)} title="انتقال به بالا">
                                                                        <i className="mir-arrow-up2 text-soft-pink "></i>
                                                                    </a>
                                                                )}
                                                            {index < this.state.data.record.items.length - 2 && (
                                                                <a onClick={(e) => this.downIndex(item.id)} title="انتقال به پایین" >
                                                                    <i className="mir-arrow-down2 text-color-blue-46"></i>
                                                                </a>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td key={"stuff_" + item.stuffId}>
                                                        <SelectAsync
                                                            style={customStyles}
                                                            defaultValue={
                                                                item.stuffId != this.defaultGuid()
                                                                    ? [
                                                                        {
                                                                            value: item.stuffId,
                                                                            label: item.stuffName,
                                                                        },
                                                                    ]
                                                                    : null
                                                            }
                                                            isMulti={false}
                                                            placeholder="انتخاب"
                                                            noOptionsMessage={({ inputValue }) =>
                                                                inputValue ? "نتیجه‌ای یافت نشد" : null
                                                            }
                                                            components={{
                                                                DropdownIndicator: () => null,
                                                                IndicatorSeparator: () => null,
                                                            }}
                                                            defaultOptions={[]}
                                                            loadOptions={this.loadStuffsOptions}
                                                            onChange={(e) =>
                                                                this.setBodyValue(item.id, 'stuffId', e)
                                                            }
                                                        />
                                                    </td>
                                                    <td>{item.unitName}</td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-input text-center"
                                                            defaultValue={item.description}
                                                            onChange={(e) => this.setBodyValue(item.id, 'description', e.target.value)}
                                                        />
                                                    </td>
                                                    {(this.state.date.record.status !== 1 && this.state.date.record.status !== 7) && <td>{item.systemQty}</td>}
                                                    {(this.state.date.record.status === 2 || this.state.date.record.status === 3 || this.state.date.record.status === 4 || this.state.date.record.status === 5 || this.state.date.record.status === 6 || this.state.date.record.status === 8) && <td>
                                                        {this.state.date.record.status === 2 ? <NumberFormat
                                                            value={item.firstCountQty}
                                                            onChange={(e) => this.setBodyValue(item.id, 'firstCountQty', parseFloat(e.target.value.replace(/,/g, '')))}
                                                            thousandSeparator={true}
                                                            prefix={''}
                                                            className="form-input text-center ltr"
                                                        />
                                                            : <span>{item.firstCountQty}</span>}
                                                    </td>}
                                                    {(this.state.date.record.status === 3 || this.state.date.record.status === 4 || this.state.date.record.status === 5 || this.state.date.record.status === 6 || this.state.date.record.status === 8) && <td>
                                                        {this.state.date.record.status === 3 ? <NumberFormat
                                                            value={item.secondCountQty}
                                                            onChange={(e) => this.setBodyValue(item.id, 'secondCountQty', parseFloat(e.target.value.replace(/,/g, '')))}
                                                            thousandSeparator={true}
                                                            prefix={''}
                                                            className="form-input text-center ltr"
                                                        />
                                                            : <span>{item.secondCountQty}</span>}
                                                    </td>}
                                                    {(this.state.date.record.status === 4 || this.state.date.record.status === 5 || this.state.date.record.status === 6 || this.state.date.record.status === 8) && <td>
                                                        {this.state.date.record.status === 4 ? <NumberFormat
                                                            value={item.thirdCountQty}
                                                            onChange={(e) => this.setBodyValue(item.id, 'thirdCountQty', parseFloat(e.target.value.replace(/,/g, '')))}
                                                            thousandSeparator={true}
                                                            prefix={''}
                                                            className="form-input text-center ltr"
                                                        />
                                                            : <span>{item.thirdCountQty}</span>}
                                                    </td>}
                                                    {(this.state.date.record.status === 5 || this.state.date.record.status === 6 || this.state.date.record.status === 8) && <td>
                                                        {this.state.date.record.status === 5 ? <NumberFormat
                                                            value={item.finalQty}
                                                            onChange={(e) => this.setBodyValue(item.id, 'finalQty', parseFloat(e.target.value.replace(/,/g, '')))}
                                                            thousandSeparator={true}
                                                            prefix={''}
                                                            className="form-input text-center ltr"
                                                        />
                                                            : <span>{item.finalQty}</span>}
                                                    </td>}
                                                    {(this.state.date.record.status === 5 || this.state.date.record.status === 6 || this.state.date.record.status === 8) && <td>
                                                        {<span>{item.differenceQty}</span>}
                                                    </td>}
                                                    {this.state.data.record.status === 1 && <td>
                                                        <div className="item-actions">
                                                            {item.stuffId != this.defaultGuid() && (
                                                                <button title="حذف سطر" onClick={(e) => this.removeRow(item.id)} className="item-delete-btn">
                                                                    <i className="mir-trash text-danger"></i>
                                                                </button>
                                                            )}
                                                            {item.stuffId != this.defaultGuid() &&
                                                                <button title="کپی سطر" onClick={(e) => this.copyRow(item.id)} className="item-copy-btn" >
                                                                    <img src="assets/images/icons/copy-item-left-bottom.svg" />
                                                                </button>
                                                            }
                                                        </div>
                                                    </td>}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="mobile-table">
                                {this.state.data.record.items.sort((a, b) => a.index - b.index).map((item, index) => (
                                    <div className="card p-3 row mt-2 flex justify-content-between" key={"mobile_" + item.id}>
                                        <div>
                                            <b>ردیف: </b>
                                            <span>{index + 1}</span>
                                            <div className="d-flex invoice-arrow-container">
                                                {index > 0 &&
                                                    index != this.state.data.record.items.length - 1 && (
                                                        <span
                                                            onClick={(e) => this.upIndex(item.id)}
                                                            title="انتقال به بالا"
                                                        >
                                                            <i className="mir-arrow-up2 text-soft-pink "></i>
                                                        </span>
                                                    )}
                                                {index < this.state.data.record.items.length - 2 && (
                                                    <span
                                                        onClick={(e) => this.downIndex(item.id)}
                                                        title="انتقال به پایین"
                                                    >
                                                        <i className="mir-arrow-down2 text-color-blue-46"></i>
                                                    </span>
                                                )}
                                            </div>
                                        </div>

                                        <div key={"stuff_" + item.stuffId}>
                                            <b>آیتم: </b>
                                            <SelectAsync
                                                style={customStyles}
                                                defaultValue={
                                                    item.stuffId != this.defaultGuid()
                                                        ? [
                                                            {
                                                                value: item.stuffId,
                                                                label: item.stuffName,
                                                            },
                                                        ]
                                                        : null
                                                }
                                                isMulti={false}
                                                placeholder="انتخاب"
                                                noOptionsMessage={({ inputValue }) =>
                                                    inputValue ? "نتیجه‌ای یافت نشد" : null
                                                }
                                                components={{
                                                    DropdownIndicator: () => null,
                                                    IndicatorSeparator: () => null,
                                                }}
                                                defaultOptions={[]}
                                                loadOptions={this.loadStuffsOptions}
                                                onChange={(e) =>
                                                    this.setBodyValue(item.id, 'stuffId', e)
                                                }
                                            />
                                        </div>
                                        <div><b>واحد: </b>{item.unitName}</div>
                                        <div>
                                            <b>توضیحات: </b>
                                            <input
                                                type="text"
                                                className="form-input text-center"
                                                defaultValue={item.description}
                                                onChange={(e) => this.setBodyValue(item.id, 'description', e.target.value)}
                                            />
                                        </div>
                                        {(this.state.date.record.status !== 1 && this.state.date.record.status !== 7) && <div>
                                            <b>موجودی سیستم: </b>{item.systemQty}
                                        </div>}
                                        {(this.state.date.record.status === 2 || this.state.date.record.status === 3 || this.state.date.record.status === 4 || this.state.date.record.status === 5 || this.state.date.record.status === 6 || this.state.date.record.status === 8) && <div>
                                            <b>شمارش اول: </b>
                                            {this.state.date.record.status === 2 ? <NumberFormat
                                                value={item.firstCountQty}
                                                onChange={(e) => this.setBodyValue(item.id, 'firstCountQty', parseFloat(e.target.value.replace(/,/g, '')))}
                                                thousandSeparator={true}
                                                prefix={''}
                                                className="form-input text-center ltr"
                                            />
                                                : <span>{item.firstCountQty}</span>}
                                        </div>}
                                        {(this.state.date.record.status === 3 || this.state.date.record.status === 4 || this.state.date.record.status === 5 || this.state.date.record.status === 6 || this.state.date.record.status === 8) && <div>
                                            <b>شمارش دوم: </b>
                                            {this.state.date.record.status === 3 ? <NumberFormat
                                                value={item.secondCountQty}
                                                onChange={(e) => this.setBodyValue(item.id, 'secondCountQty', parseFloat(e.target.value.replace(/,/g, '')))}
                                                thousandSeparator={true}
                                                prefix={''}
                                                className="form-input text-center ltr"
                                            />
                                                : <span>{item.secondCountQty}</span>}
                                        </div>}
                                        {(this.state.date.record.status === 4 || this.state.date.record.status === 5 || this.state.date.record.status === 6 || this.state.date.record.status === 8) && <div>
                                            <b>شمارش سوم: </b>
                                            {this.state.date.record.status === 4 ? <NumberFormat
                                                value={item.thirdCountQty}
                                                onChange={(e) => this.setBodyValue(item.id, 'thirdCountQty', parseFloat(e.target.value.replace(/,/g, '')))}
                                                thousandSeparator={true}
                                                prefix={''}
                                                className="form-input text-center ltr"
                                            />
                                                : <span>{item.thirdCountQty}</span>}
                                        </div>}
                                        {(this.state.date.record.status === 5 || this.state.date.record.status === 6 || this.state.date.record.status === 8) && <div>
                                            <b>موجودی نهایی: </b>
                                            {this.state.date.record.status === 5 ? <NumberFormat
                                                value={item.finalQty}
                                                onChange={(e) => this.setBodyValue(item.id, 'finalQty', parseFloat(e.target.value.replace(/,/g, '')))}
                                                thousandSeparator={true}
                                                prefix={''}
                                                className="form-input text-center ltr"
                                            />
                                                : <span>{item.finalQty}</span>}
                                        </div>}
                                        {(this.state.date.record.status === 5 || this.state.date.record.status === 6 || this.state.date.record.status === 8) && <div>
                                            <b>اختلاف موجودی: </b>
                                            {<span>{item.differenceQty}</span>}
                                        </div>}
                                        {this.state.data.record.status === 1 && <div>
                                            <div className="item-actions">
                                                {item.stuffId != this.defaultGuid() && (
                                                    <button title="حذف سطر" onClick={(e) => this.removeRow(item.id)} className="item-delete-btn" >
                                                        <i className="mir-trash text-danger"></i>
                                                    </button>
                                                )}
                                                {item.stuffId != this.defaultGuid() &&
                                                    <button title="کپی سطر" onClick={(e) => this.copyRow(item.id)} className="item-copy-btn">
                                                        <img src="assets/images/icons/copy-item-left-bottom.svg" />
                                                    </button>
                                                }
                                            </div>
                                        </div>}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="modal-footer flex flex-row gap-4">
                            <a className="btn btn-secendry" onClick={(e) => this.closeMe()}>انصراف</a>
                            {(this.state.data.record.status === 1 || this.state.data.record.status === 7) && this.state.data.record.id !== this.defaultGuid() && <a className="btn btn-danger" onClick={e => this.confirmRemove(this.state.data.record.id)} >حذف</a>}
                            {1 == 2 && this.state.data.record.id !== this.defaultGuid() && <a onClick={(e) => this.getPdf(this.state.data.record.id)} className="btn btn-blue">PDF</a>}
                            {this.state.data.record.status === 1 && <a onClick={(e) => this.save(e, 1)} className="btn btn-success">ذخیره - موقت</a>}
                            {this.state.data.record.status === 1 && <a onClick={(e) => this.save(e, 2)} className="btn btn-success">شروع شمارش</a>}
                            {this.state.data.record.status === 2 && <a onClick={(e) => this.save(e, 3)} className="btn btn-success">تایید شمارش اول</a>}
                            {this.state.data.record.status === 3 && <a onClick={(e) => this.save(e, 4)} className="btn btn-success">تایید شمارش دوم</a>}
                            {this.state.data.record.status === 4 && <a onClick={(e) => this.save(e, 5)} className="btn btn-success">تایید شمارش سوم</a>}
                            {this.state.data.record.status === 5 && <a onClick={(e) => this.save(e, 6)} className="btn btn-success">تایید نهایی</a>}
                            {this.state.data.record.status === 6 && <a onClick={(e) => this.save(e, 8)} className="btn btn-success">صدور اسناد اصلاحی</a>}
                            {this.state.data.record.status !== 1 && this.state.data.record.status !== 8 && this.state.data.record.id !== this.defaultGuid() && <a onClick={(e) => this.save(e, 7)} className="btn btn-danger">لغو</a>}
                        </div>
                    </div>
                </div>
            </div>
        ];
    }
    render() {
        if (!this.isBlank(this.state.redirect))
            return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading
            ? this.renderLoading()
            : [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent(),
            ];

        return contents;
    }
}